module.exports = __webpack_public_path__ + "static/39-17ee8e1791b082e37f2defcdeea8b7d4.png";